import type { NavigationMenuTriggerProps } from '@radix-ui/react-navigation-menu'
import type { PropsWithChildren } from 'react'
import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import cn from 'classnames'
import TopNavigationBarItem from '@/scopes/common/components/Header/TopNavigationBarItem'
import { wrapTextChildrenWithTypography } from '@/scopes/common/components/Header/typography'
import styles from './Trigger.module.css'

export function MenuTrigger({ children, className, ...rest }: PropsWithChildren<NavigationMenuTriggerProps>) {
  return (
    <NavigationMenu.Trigger asChild {...rest}>
      <TopNavigationBarItem className={cn(styles.menuTrigger, className)}>
        {wrapTextChildrenWithTypography(children)}
      </TopNavigationBarItem>
    </NavigationMenu.Trigger>
  )
}
